import { createSlice } from "@reduxjs/toolkit";
import {
  districtData,
  DistrictInitialStatus,
} from "../../../../types/geo/geo";
import { capitalize } from "../../../../utils/string";
import {
  createDistrictAsync,
  deleteDistrictAsync,
  getAllDistrictListAsync,
  getSingleDistrictAsync,
  updateDistrictAsync,
} from "./districtApi";

const initialState: DistrictInitialStatus<districtData> = {
  loading: false,
  manageLoading: false,
  districtList: [],
  singleDistrictData: null,
  countDistrict: 0,
};

const districtSlice = createSlice({
  name: "admin-district",
  initialState,
  reducers: {
    resetSingleDistrict: (state) => {
      state.singleDistrictData = null;
    },
  },
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createDistrictAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createDistrictAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createDistrictAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllDistrictListAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllDistrictListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.districtList = (action.payload?.data || []).map((item) => ({
          ...item,
          districtName: capitalize(item.districtName),
          division_id:
            typeof item.division_id === "object" && item.division_id !== null
              ? {
                  ...item.division_id,
                  divisionName: capitalize((item.division_id as any).divisionName),
                }
              : item.division_id,
        }));
        state.countDistrict = action.payload?.length || 0;
      })
      .addCase(getAllDistrictListAsync.rejected, (state) => {
        state.loading = false;
        state.districtList = [];
        state.countDistrict = 0;
      });

    // get single
    builder
      .addCase(getSingleDistrictAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleDistrictData = null;
      })
      .addCase(getSingleDistrictAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleDistrictData = action.payload
          ? {
              ...action.payload,
              districtName: capitalize(action.payload.districtName),
              division_id:
                typeof action.payload.division_id === "object" && action.payload.division_id !== null
                  ? {
                      ...action.payload.division_id,
                      divisionName: capitalize((action.payload.division_id as any).divisionName),
                    }
                  : action.payload.division_id,
            }
          : null;
      })
      .addCase(getSingleDistrictAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleDistrictData = null;
      });

    // update
    builder
      .addCase(updateDistrictAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateDistrictAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateDistrictAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // delete
    builder
      .addCase(deleteDistrictAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(deleteDistrictAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(deleteDistrictAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export const { resetSingleDistrict } = districtSlice.actions;
export default districtSlice;
